import { Box, Typography } from "@mui/material";
import useColors from "../api/hooks/useColors";
import SvgToIcon from "../icons/SvgToIcon";
import { inputIcons } from "../scenes/stack/environment/icons/iconExport";

const UploadCaption = ({ variant = "info", caption }) => {
  const colors = useColors();

  if (!caption) {
    return null;
  }

  const getVariantConfig = () => {
    switch (variant) {
      case "success":
        return {
          icon: inputIcons.successIcon,
          color: colors.success_dark,
          backgroundColor: colors.background_default,
        };
      case "error":
        return {
          icon: inputIcons.errorIcon,
          color: colors.error_main,
          backgroundColor: colors.background_default,
        };
      case "info":
      default:
        return {
          icon: inputIcons.infoIcon,
          color: colors.text_disabled,
          backgroundColor: colors.background_default,
        };
    }
  };

  const config = getVariantConfig();

  return (
    <Box display="flex" alignItems="center" gap={0.5} ml={1}>
      <SvgToIcon
        IconLogo={config.icon}
        style={{
          width: "12px",
          height: "12px",
          color: config.color,
        }}
      />
      <Typography variant="caption" color={config.color}>
        {caption}
      </Typography>
    </Box>
  );
};

export default UploadCaption;
